import data from './data'

export default {
  data,
  resourcePath: '/v1/patient/settings/terms'
}



// WEBPACK FOOTER //
// ./src/app/patient/terms/index/resources/index.js